import NotificationsNotifications from './NotificationsNotifications.vue';

export default NotificationsNotifications;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/notification/views/notifications/index.ts